import React from "react";
import { useSelector } from "react-redux";
import { providerSelector } from "redux/selectors/providerSelectors";
import "./PodiatryMenu.scss";

const chiropracticContentByYear = {
    2026: {
        description:
            "Eligible Alignment Health Plan members have access to Medicare covered and/or routine acupuncture, chiropractic, and/or massage therapy. Coverage varies by plan and members should refer to their Evidence of Coverage (EOC) for plan specific information.",
        routineBenefits:
            "Routine acupuncture, chiropractic, and/or massage therapy are provided through American Specialty Health (ASH).",
    },
    2027: {
        description:
            "Eligible Alignment Health Plan members have access to Medicare covered and/or routine acupuncture, chiropractic, massage therapy, and/or alternative therapeutic services. Coverage varies by plan and members should refer to their Evidence of Coverage (EOC) for plan specific information.",
        routineBenefits:
            "Routine acupuncture, chiropractic, massage therapy, and/or alternative therapeutic benefits are provided through American Specialty Health (ASH).",
    },
} as const;

const ChiropracticMenu = () => {
    const selector = providerSelector;
    const selectedCoverageYear = useSelector(selector.selectedCoverageYear);

    const content =
        chiropracticContentByYear[
            selectedCoverageYear as keyof typeof chiropracticContentByYear
        ];

    if (!content) {
        return null;
    }

    return (
        <section className="podiatry-menu">
            <div className="podiatry-menu__notice">
                <p>
                    Benefits vary by plan. Please refer to your
                    Evidence of Coverage (EOC) for benefit details and to determine
                    whether your plan includes additional supplemental services.
                </p>
                <p>
                    If you need assistance, please contact the ACCESS On-Demand
                    Concierge at
                    <a href="tel:18332422223"> 1-833-242-2223 </a>
                    (TTY: 711), available 24 hours a day, 7 days a week.
                </p>
            </div>

            <p className="podiatry-menu__text">
                {content.description}
            </p>

            <h3 className="podiatry-menu__heading">North Carolina Plan Notice:</h3>

            <p className="podiatry-menu__text">
                Eligible members in North Carolina have access to providers within the
                American Specialty Health (ASH) network for Medicare covered
                acupuncture services. To find an in-network provider, click the button
                below to be redirected to the American Specialty Health (ASH)
                provider search.
            </p>

            <h3 className="podiatry-menu__heading">Medicare Covered Services</h3>

            <p className="podiatry-menu__text">
                To find an in-network provider, click on the &ldquo;Doctors&rdquo;
                button above (located on the far left) and search the doctor type you
                are requesting.
            </p>

            <h3 className="podiatry-menu__heading">Routine Benefits</h3>

            <p className="podiatry-menu__text">
                {content.routineBenefits}
            </p>

            <p className="podiatry-menu__text">
                To find an in-network provider for routine services, click the button
                below to be redirected to the American Specialty Health (ASH)
                provider search.
            </p>

            <a
                className="podiatry-menu__cta"
                href="https://www.ashlink.com/ASH/public/applications/NetworkSearch/NetworkSearch.aspx"
                target="_blank"
                rel="noreferrer"
            >
                Find a Provider from the American Specialty Health (ASH)
            </a>
        </section>
    );
};

export default ChiropracticMenu;